export default {
  v2: {
    filters: {
      label: "{count} Filter{count, plural, =0 {} =1 {} other{s}}",
    },
    leadsList: {
      title: "Lead Management",
      description:
        "With Lead Management you can now get all your leads in one place.",
      learnMore: "Learn more",
      viewOlderLeads: "View older Leads",
      searchResult:
        "{count} SEARCH RESULT{count, plural, =0 {} =1 {} other{S}}",
      today: "Today",
      yesterday: "Yesterday",
      week: "This Week",
      older: "Older",
      quality: {
        HOT: "Hot",
        WARM: "Warm",
        COLD: "Cold",
        NEW: "Newbie",
        OLD: "Old",
      },
      type: {
        SALE: "Sale",
        RENT: "Rent",
      },
      agentProfile: {
        message: "Interested to enquire about properties",
      },
      listing: {
        deleted: {
          message: "Listing has been deleted",
        },
      },
      role: {
        AGENT: "Agent",
      },
      header: "Leads",
    },
    noLeads: {
      title: "You have no leads yet",
      description: "Once you get leads, it’ll appear here",
    },
    noLeadsSelected: {
      title: "No leads selected",
      description: "Select leads to see the insights",
    },
    search: {
      placeholder: {
        default: "Search enquirer name, email or listing",
        listingDetails: "Search listing...",
        enquirers: "Search enquirer...",
      },
      dropdown: {
        placeholder: {
          listingDetails:
            "Start typing at least 3 characters for listing name or listing ID to search.",
          enquirers:
            "Start typing at least 3 characters for enquirer name, phone number or email to search.",
        },
      },
      noResult: {
        title: "No matches found",
        description: "Please check your search terms, or try another search",
      },
      listingDetails: {
        builtUp: `Built up: {value}`,
        price: `{unit}{price}`,
        id: `iPP ID: { id }`,
        status: {
          active: "Active",
          inactive: "Inactive",
        },
      },
    },
    systemError: {
      title: "Oops, something went wrong!",
      description: "Sorry, there seems to be an unexpected error.",
    },
    filterResultEmpty: {
      title: "We couldn't find any leads that match your refinements.",
      description:
        "Try changing your criteria to find the leads you are after.",
    },
    lead: {
      leadQuality: {
        HOT: "This enquirer is very active.",
        WARM: "This enquirer is quite active.",
        NEW: "This enquirer is new to the platform.",
        OLD: "This lead is more than 60 days old and will no longer be updated. To continue contacting this lead, please obtain enquirer's consent.",
        NORMAL:
          "This enquirer is moderately active on iProperty, please contact them soon.",
      },
      insights: {
        tooltip:
          "These are interesting information about the enquirer. The insights are based on the enquirer's recent activities on iProperty.",
        disclaimer: {
          title: "Disclaimer : ",
          message:
            "PropertyGuru and iProperty do not guarantee the completeness or accuracy of the lead information. If the lead is older than 60 days, please do not contact the enquirer.",
        },
      },
      role: {
        AGENT: {
          title: "Agent",
          tooltip: "Based on the activity on iProperty, this is an agent.",
        },
      },
      bedroomBathroom:
        "{bedroom} bedroom{bedroom, plural, =0 {} =1 {} other{s}} | {bathroom} bathroom{bathroom, plural, =0 {} =1 {} other{s}}",
      recentlyContacted:
        "{agent} agent{agent, plural, =0 {} =1 {} other{s}} in 7 days",
      recentlyContactedMoreThan: "More than {agent} agents in 7 days",
      noInsight: {
        title: "No Insights",
        description:
          "This enquirer is new to iProperty, and no clear insights are available yet.",
      },
      preferencesUnavailable: {
        title: "Data not available",
        description:
          "Insights will be made available at 11am tomorrow, please check back again.",
      },
      historyOfInterest: {
        tooltip:
          "These are when and how the enquirer has shown interest for this listing.",
      },
      verifiedLead: {
        title: "Verified Lead",
        tooltip:
          "Verified leads are confirmed enquiries with valid contact details from buyers, renters, or sellers",
      },
      interestShownHistory: {
        title: "Interest Shown History",
        button: {
          viewHistory: "View history",
          dismiss: "Dismiss",
        },
      },
      filtersErrorAlert: {
        message: "Something went wrong. Please try again later.",
      },
    },
    learnMore: {
      title: "Help",
    },
    whatsapp: {
      propertyguruLinkPrefix: "PropertyGuru: {url}",
      ipropertyLinkPrefix: "iProperty: {url}",
    },
    label: {
      feedback_message: "Share your experience",
      feedback: {
        title: "Help us improve",
        input_title: "Tell us about your experience",
        input_placeholder: "Please describe in detail",
      },
    },
    common: {
      option: {
        skip: "Skip",
        submit: "Submit",
      },
    },
    toast: {
      feedback: {
        submitted: "Thanks for your feedback!",
      },
    },
  },
};
